
import { memCacheGet, memCacheSet } from '../memCache'
import { HttpVerb } from '../constants/HttpVerb'
import { useState, useEffect } from 'react'

export async function getUsers() {
  const promise = fetch('/static/users/users.json', {
      headers: { 'Content-Type': 'application/json' },
      method: HttpVerb.GET,
    })

    return await promise.then(r =>  r.json())
}

export function useUser(name: string) {
  const [user, setUser] = useState<any>(null)
  const [isLoading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    const fetchUser = async () => {
      const users = await getUsers()
      const u = users.find((u: any) => u.displayName === name)
      setUser(u)
      setLoading(false)
    }

    if (name && !user && !isLoading) {
      setLoading(true)
      fetchUser()
    }
  }, [name])

  return {user, isLoading, error}
}

export default function useUserNames() {
  const [data, setData] = useState<any[]>(memCacheGet('user_list') ?? ['All Users'])
  const [isLoading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string>('')

  useEffect(() => {
    async function fetchData() {
      // Retrieve data from the API
      let newData = await getUsers()
      if (newData) newData = newData.map((u: any) => u.displayName)
      newData?.unshift("All Users")
          
      memCacheSet('user_list', newData)
      setData(newData)
      setLoading(false)
    }

    if (data.length === 1 && !isLoading) {
      setLoading(true)
      fetchData().catch((error) => { setError(error) })
    }
  }, [data, isLoading])

  return {data, isLoading, error}
}
